"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDictionary = void 0;
const transformDictionary = (mapper, inputDictionary = []) => {
    const temp = inputDictionary.reduce((prev, next) => (Object.assign(Object.assign({}, prev), { [next.Key]: next.Value })), {});
    return Object.keys(mapper).reduce((prev, next) => (Object.assign(Object.assign({}, prev), { [next]: temp[mapper[next]] })), {});
};
exports.transformDictionary = transformDictionary;
